/* global createElementToast */
const clickEventCopyLinkToClipboard = {
	el: {
		body: document.body,
		copyLinkItem: document.querySelectorAll('.js-copy-link'),
		copyLinkImage: document.querySelector('.js-copy-link-image'),
		copyLinkText: document.querySelector('.js-copy-link-text')
	},

	fxCopyLinkToClipBoard(el) {
		// save current icon
		let currentImg = this.el.copyLinkImage.src

		// save current text
		let currentText = this.el.copyLinkText.textContent

		el.addEventListener('click', e => {
			e.preventDefault()
			const inputElement = document.createElement('input'),
				urlCurrentPage = location.href,
				imgSrcSuccess = this.el.copyLinkImage.dataset.imgLinkCopied

			this.el.body.appendChild(inputElement)
			inputElement.value = urlCurrentPage
			inputElement.select()
			navigator.clipboard.writeText(inputElement.value)
			createElementToast.fxCreateToastItem('success', e.currentTarget.dataset.toastCopy)
			this.el.copyLinkImage.src = imgSrcSuccess
			this.el.copyLinkText.textContent = 'copied'
			this.el.body.removeChild(inputElement)

			setTimeout(() => {
				this.el.copyLinkImage.src = currentImg
				this.el.copyLinkText.textContent = currentText
			}, 500)
		})
	},

	init() {
		for (const element of this.el.copyLinkItem)
			this.fxCopyLinkToClipBoard(element)
	}

}

clickEventCopyLinkToClipboard.init()